import { Component, inject } from '@angular/core';
import { Dialog } from '../dialog';
import {
  EEntityType,
  ERelationType,
  ITicket,
  NamedTariffProductDefinition,
  TariffSelectionAttribute,
} from '@web/dtos';
import { ButtonComponent } from '../../feedback/button/button.component';
import { DialogComponent } from '../dialog/dialog.component';
import { ToTicketTilePipe } from '../../../pipes/to-ticket-tile/to-ticket-tile.pipe';
import { TicketOptionsFormComponent } from '../../data-input/ticket-options-form/ticket-options-form.component';
import {
  ITicketDefinitionForm,
  ShoppingCartFormService,
} from '../../../services/shopping-cart/shopping-cart-form.service';
import { FormGroup } from '@angular/forms';
import { ShoppingCartService } from '../../../services/shopping-cart/shopping-cart.service';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';

@Component({
  selector: 'aw-direct-ticket-edit-options-shopping-cart-dialog',
  imports: [
    ButtonComponent,
    DialogComponent,
    ToTicketTilePipe,
    TicketOptionsFormComponent,
    FilterTextsPipe,
    LanguagePipe,
  ],
  templateUrl:
    './direct-ticket-edit-options-shopping-cart-dialog.component.html',
})
export class DirectTicketEditOptionsShoppingCartDialogComponent extends Dialog<{
  index: number;
  name: string;
  ticket: ITicket;
  selectionAttributes: TariffSelectionAttribute[];
  productSortOptions: TariffSelectionAttribute[];
  productDefinition: NamedTariffProductDefinition;
}> {
  private readonly shoppingCartFormService: ShoppingCartFormService = inject(
    ShoppingCartFormService
  );
  private readonly shoppingCartService: ShoppingCartService =
    inject(ShoppingCartService);
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly productForm: FormGroup<ITicketDefinitionForm> =
    this.shoppingCartFormService.createProductForm(
      this.data.selectionAttributes,
      this.data.productSortOptions,
      this.getProductFormFromCart(this.data.index)?.value
    );

  private getProductFormFromCart(
    index: number
  ): FormGroup<ITicketDefinitionForm> {
    return this.shoppingCartService.productForms.controls[index];
  }

  protected saveChanges(): void {
    const form: FormGroup<ITicketDefinitionForm> = this.getProductFormFromCart(
      this.data.index
    );
    form.setValue({
      tariffGroup: this.productForm.value.tariffGroup,
      selectionAttributes: this.productForm.value.selectionAttributes!,
      productSortOptions: this.productForm.value.productSortOptions!,
      additionalEntries:
        this.productForm.controls.additionalEntries.getRawValue(),
      product: this.productForm.value.product,
      amount: this.productForm.value.amount!,
      amountOfPeople: this.productForm.value.amountOfPeople!,
      travelDate: this.productForm.value.travelDate!,
    });
    this.dialogRef.close();
  }

  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
}
